








































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import VueDraggable from 'vuedraggable'
import { cloneDeep } from 'lodash'
import { ReportBrRow } from '../table-data/ReportBrRow';
import { Segmentation } from '../../../common/types/roots/fields';
import { Classificator } from '../../../common/types/Classificator';
import { Indicator } from '../../../common/types/Indicator';
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"
import { Draggable } from '../../../common/types/Draggable';
import { reportBrIndicators } from '../report-br';

interface BrColumnGroup {
    key: string
    label: string
    rowspan: number
    colspan: number
    subCols: Array<{ key: string; label: string }>
    dataCols: string[]
    fixed?: boolean
}

// Количество строк, удерживаемых в DOM в любой момент
const WINDOW_SIZE = 100
// Строки-буфер выше/ниже видимой области
const SCROLL_BUFFER = 60

@Component({
    components: {
        'draggable': VueDraggable,
    }
})
export default class ReportBr extends Vue {

    @Prop({
        type: Array,
        required: true,
    })
    public tableData!: ReportBrRow[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly expenses!: Classificator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly segmentation!: Draggable<Segmentation>[]

    @Prop({
        type: Boolean,
        required: false,
        default: false,
    })
    private readonly planByMonths!: boolean

    @Prop({
        type: Boolean,
        required: false,
        default: true,
    })
    private readonly hideZeroProjects!: boolean

    @Prop({
        type: Array,
        required: false,
        default: () => cloneDeep(reportBrIndicators),
    })
    private readonly propIndicators!: Indicator[]

    private readonly monthColumns = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']

    private readonly colClassMap: Record<string, string> = {
        name: 'col-name',
        utilization_percent: 'col-pct',
        reason_plat: 'col-text',
        reason_obaz: 'col-text',
        supplier: 'col-sup',
        beg_date: 'col-date',
        end_date: 'col-date',
    }

    private readonly segColClassMap: Record<string, string> = {
        gr_pgr: 'col-grpgr',
        kbk: 'col-kbk',
        gu: 'col-gu',
    }

    public activePlanByMonths: boolean = false
    public totalExpand: boolean = true
    public segmentationColumns: string[] = []
    public tableGroups: BrColumnGroup[] = []
    public indicators: Indicator[] = []

    public projectColumns = ['reason_plat', 'reason_obaz', 'supplier', 'beg_date', 'end_date']

    // Поля, участвующие в проверке «все нули» для строки проекта.
    // Исключены: текстовые (name, reason_plat, reason_obaz, supplier, beg_date, end_date)
    // и расчётные (utilization_percent, plan_remainder_period, plan_remainder_month).
    private readonly numericCheckFields: string[] = [
        'utv_plan', 'utoch_plan', 'skor_plan',
        'plat', 'obaz', 'registrob',
        'sumrg', 'curr_sumrg', 'plan_month',
        'january', 'february', 'march', 'april', 'may', 'june',
        'july', 'august', 'september', 'october', 'november', 'december',
    ]

    public rowTypeColorsMap: Record<string, string> = {
        'total': '#00B0F0',
        'total_funding': '#F8CBAD',
        'region': '#00B0F0',
        'funding': '#F8CBAD',
        'funding_extended': '#BDD7EE',
        'project': '#c2e3f2',
        'project_detailed': '#FFFFFF',
        'project_full': '#FFFFFF',
    }

    public columnsNameMap: Record<string, string> = {
        'gr_pgr': 'Функц. группа',
        'kbk': 'Код бюджетной классификации',
        'spf': 'Специфика',
        'gu': 'ГУ',
        'name': 'Наименование',
        'utv_plan': 'Утвержденный бюджет',
        'utoch_plan': 'Уточненный бюджет',
        'skor_plan': 'Скорректированный бюджет',
        'months_group': 'Скорректированный бюджет по месяцам',
        'svod_plan': 'Сводный план поступлений и финансирования, сводный план финансирования по обязательствам на отчетный период',
        'plat': 'по платежам',
        'obaz': 'по обязательствам',
        'plan_month': 'Сводный план финансирования за отчетный месяц',
        'registrob': 'Принятые обязательства',
        'sumrg_group': 'Кассовое исполнение',
        'sumrg': 'на отчетный период',
        'curr_sumrg': 'за отчетный месяц',
        'utilization_percent': '% освоения',
        'january': 'Январь',
        'february': 'Февраль',
        'march': 'Март',
        'april': 'Апрель',
        'may': 'Май',
        'june': 'Июнь',
        'july': 'Июль',
        'august': 'Август',
        'september': 'Сентябрь',
        'october': 'Октябрь',
        'november': 'Ноябрь',
        'december': 'Декабрь',
        'plan_remainder_group': 'Остаток от плана',
        'plan_remainder_period': 'на отчетный период',
        'plan_remainder_month': 'за отчетный месяц',
        'reason_plat': 'Причины не освоения',
        'reason_obaz': 'Причины не принятых обязательств',
        'supplier': 'Наименование подрядчика',
        'date_text': 'Срок реализации',
        'beg_date': 'начало реализации (месяц,год)',
        'end_date': 'срок завершения (акт ввода №, дата)',
    }

    // Состояние virtual scroll (реактивные)
    private virtualStart = 0
    private virtualEnd = WINDOW_SIZE
    private rowHeight = 60
    private topSpacerHeight = 0
    private bottomSpacerHeight = 0
    private isScrolling = false

    // Строки, которые сейчас рендерятся в DOM (виртуальное окно)
    private vsRows: ReportBrRow[] = []
    // Общее количество видимых строк (для расчёта спейсеров)
    private vsTotal: number = 0

    // Нереактивные поля (Vue 2 не проксирует _-префиксные свойства)
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    private _scrollRaf: number | null = null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _scrollPointerTimer: any = null
    private _rowHeights: number[] = []
    private _prefixSum: number[] = [0]

    get columns(): string[] {
        return this.tableGroups
            .filter(g => !g.fixed)
            .flatMap(g => g.dataCols)
    }

    get totalColspan(): number {
        return 1 + this.segmentationColumns.length + this.columns.length
    }

    // Набор видимых числовых полей, по которым проверяем «все нули»
    get checkableFields(): string[] {
        const visibleDataCols = this.tableGroups
            .filter(g => !g.fixed)
            .flatMap(g => g.dataCols)
        return visibleDataCols.filter(col => this.numericCheckFields.includes(col))
    }

    // Строки после применения фильтра «Убрать нулевые проекты».
    // Скрывает строку если её поддерево целиком нулевое.
    // Нулевой родитель с ненулевыми детьми остаётся видимым.
    // Spread при toggle=OFF — гарантирует новую ссылку для @Watch('filteredRows').
    get filteredRows(): ReportBrRow[] {
        if (!this.hideZeroProjects) {
            return [...this.tableData]
        }

        const fields = this.checkableFields
        if (!fields.length) return [...this.tableData]

        const rows = this.tableData
        const n = rows.length

        // Шаг 1: есть ли у строки собственные ненулевые значения
        const subtreeHasValue = rows.map(row =>
            fields.some(f => {
                const val = (row as unknown as Record<string, unknown>)[f]
                return !!val && Number(val) !== 0
            })
        )

        // Шаг 2: распространяем «живость» снизу вверх — если у потомка есть значения,
        // родитель остаётся видимым (нулевой родитель ≠ нулевое поддерево)
        for (let i = n - 1; i >= 0; i--) {
            if (subtreeHasValue[i]) {
                const childLevel = rows[i].level
                for (let j = i - 1; j >= 0; j--) {
                    if (rows[j].level < childLevel) {
                        subtreeHasValue[j] = true
                        break
                    }
                }
            }
        }

        // Шаг 3: строка видима если поддерево не пустое; total/total_funding всегда показываем
        return rows.filter((row, i) => {
            const t = row.type
            if (t === 'total' || t === 'total_funding') return true
            return subtreeHasValue[i]
        })
    }

    private _getFiltered(): ReportBrRow[] {
        return this.filteredRows.filter(r => r.visible)
    }

    private created() {
        this.indicators = cloneDeep(this.propIndicators)
        this.setupDisplay()
        // Первичная инициализация vsRows
        const filtered = this._getFiltered()
        this.vsTotal = filtered.length
        this.vsRows = filtered.slice(0, Math.min(WINDOW_SIZE, filtered.length))
    }

    private mounted() {
        this.$nextTick(() => {
            const container = this.$refs.tableContainer as HTMLElement
            if (!container) return
            const firstRow = container.querySelector('tbody tr') as HTMLElement | null
            if (firstRow && firstRow.offsetHeight > 0) {
                this.rowHeight = firstRow.offsetHeight
            }
            const filtered = this._getFiltered()
            this.vsTotal = filtered.length
            this.initRowHeights(this.vsTotal)
            this.virtualEnd = Math.min(WINDOW_SIZE, this.vsTotal)
            this.vsRows = filtered.slice(0, this.virtualEnd)
            // Capture-phase listener отлавливает scroll на любом элементе дерева документа
            window.addEventListener('scroll', this.onScroll, { passive: true, capture: true })
        })
    }

    private beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll, true)
        if (this._scrollRaf !== null) cancelAnimationFrame(this._scrollRaf)
        if (this._scrollPointerTimer !== null) clearTimeout(this._scrollPointerTimer)
    }

    @Watch('tableData')
    private onTableDataChanged() {
        this.setupDisplay()
        this._reinitVsRows()
    }

    @Watch('hideZeroProjects')
    private onHideZeroProjectsChanged() {
        this._reinitVsRows()
    }

    @Watch('filteredRows')
    private onFilteredRowsChanged() {
        this._reinitVsRows()
        this.$emit('update-excel-items', this.filteredRows)
    }

    private _reinitVsRows() {
        const filtered = this._getFiltered()
        this.vsTotal = filtered.length
        this.virtualStart = 0
        this.virtualEnd = Math.min(WINDOW_SIZE, this.vsTotal)
        this.topSpacerHeight = 0
        this.bottomSpacerHeight = 0
        this.initRowHeights(this.vsTotal)
        this.vsRows = filtered.slice(0, this.virtualEnd)
    }

    // Инициализация массива высот строк и пересчёт prefix-sum
    private initRowHeights(count: number): void {
        const rh = this.rowHeight
        this._rowHeights = new Array(count).fill(rh)
        this.rebuildPrefixSum()
    }

    // O(n) полная перестройка prefix-sum. Нереактивна — не вызывает ре-рендер Vue
    private rebuildPrefixSum(): void {
        const n = this._rowHeights.length
        const ps = new Array(n + 1)
        ps[0] = 0
        for (let i = 0; i < n; i++) {
            ps[i + 1] = ps[i] + this._rowHeights[i]
        }
        this._prefixSum = ps
    }

    // Бинарный поиск: наибольший i, где _prefixSum[i] <= scrollPos
    private findRowAtScrollPos(scrollPos: number): number {
        if (this._prefixSum.length < 2) return Math.floor(scrollPos / this.rowHeight)
        let lo = 0
        let hi = this._prefixSum.length - 2
        while (lo < hi) {
            const mid = (lo + hi + 1) >> 1
            if (this._prefixSum[mid] <= scrollPos) lo = mid
            else hi = mid - 1
        }
        return lo
    }

    // Измерение высот отрендеренных строк и обновление _prefixSum при изменениях.
    // Прыжок при изменении высоты строки предотвращает overflow-anchor: auto на контейнере.
    private measureRenderedRows(): void {
        const container = this.$refs.tableContainer as HTMLElement
        if (!container || !this._rowHeights.length) return
        const rows = container.querySelectorAll<HTMLElement>('tbody tr[data-row-index]')
        let changed = false
        rows.forEach(row => {
            const idx = parseInt(row.dataset.rowIndex ?? '')
            const h = row.offsetHeight
            if (!isNaN(idx) && h > 0 && idx < this._rowHeights.length && this._rowHeights[idx] !== h) {
                this._rowHeights[idx] = h
                changed = true
            }
        })
        if (changed) this.rebuildPrefixSum()
    }

    // Пересчёт отображаемого среза на основе текущей позиции скролла
    private syncVirtualWindow(): void {
        const container = this.$refs.tableContainer as HTMLElement
        if (!container) return

        let scrolledIntoContainer: number
        if (container.scrollTop > 0) {
            scrolledIntoContainer = container.scrollTop
        } else {
            const containerTop = container.getBoundingClientRect().top
            scrolledIntoContainer = Math.max(0, -containerTop)
        }

        const firstVisibleRow = this.findRowAtScrollPos(scrolledIntoContainer)
        const total = this.vsTotal

        const rawStart = Math.max(0, firstVisibleRow - SCROLL_BUFFER)
        const rawEnd = Math.min(total, rawStart + WINDOW_SIZE)
        const adjustedStart = Math.max(0, rawEnd - WINDOW_SIZE)

        this.virtualStart = adjustedStart
        this.virtualEnd = rawEnd

        const ps = this._prefixSum
        const end = Math.min(rawEnd, total)
        this.topSpacerHeight = ps.length > adjustedStart ? ps[adjustedStart] : adjustedStart * this.rowHeight
        this.bottomSpacerHeight = ps.length > total
            ? Math.max(0, ps[total] - ps[end])
            : Math.max(0, (total - end) * this.rowHeight)

        this.vsRows = this._getFiltered().slice(this.virtualStart, this.virtualEnd)

        this.$nextTick(() => this.measureRenderedRows())
    }

    private onScroll(): void {
        // Отключаем pointer-events во время скролла для предотвращения перекраски hover
        if (!this.isScrolling) this.isScrolling = true
        if (this._scrollPointerTimer !== null) clearTimeout(this._scrollPointerTimer)
        this._scrollPointerTimer = setTimeout(() => { this.isScrolling = false }, 150)

        // Используем != null (нестрогое) т.к. Vue 2 не проксирует _-prefixed свойства,
        // поэтому this._scrollRaf читается как undefined (не null) до первой записи.
        // eslint-disable-next-line eqeqeq
        if (this._scrollRaf != null) return
        this._scrollRaf = requestAnimationFrame(() => {
            try {
                this.syncVirtualWindow()
            } finally {
                this._scrollRaf = null
            }
        })
    }

    private setupDisplay() {
        this.tableData.forEach((r: any, i: number) => { r._dataIndex = i })
        this.activePlanByMonths = this.planByMonths

        this.segmentationColumns = []
        const expenseActive = (key: string) => this.expenses.find(e => e.key === key)?.active ?? true
        this.segmentation.forEach(s => {
            if (s.value === 'KBK' && s.active) {
                if (expenseActive('gr') || expenseActive('pgr')) this.segmentationColumns.push('gr_pgr')
                if (expenseActive('abp') || expenseActive('prg') || expenseActive('ppr')) this.segmentationColumns.push('kbk')
                if (expenseActive('spf')) this.segmentationColumns.push('spf')
            } else if (s.value === 'GU' && s.active) {
                this.segmentationColumns.push('gu')
            }
        })

        this.buildTableGroups()
    }

    private buildTableGroups() {
        const groups: BrColumnGroup[] = []

        // Fixed: кнопка expand
        groups.push({
            key: 'expand_btn',
            label: '',
            rowspan: 2,
            colspan: 1,
            subCols: [],
            dataCols: [],
            fixed: true,
        })

        // Fixed: колонки сегментации
        this.segmentationColumns.forEach(col => {
            groups.push({
                key: col,
                label: this.columnsNameMap[col] ?? col,
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: [col],
                fixed: true,
            })
        })

        // Группы показателей в сохранённом порядке (только активные)
        const indicatorGroupDefs = this.buildIndicatorGroupDefs()
        this.indicators.forEach(ind => {
            if (!ind.active) return
            const def = indicatorGroupDefs[ind.key]
            if (def) {
                groups.push(def)
            }
        })

        this.tableGroups = groups
    }

    private buildIndicatorGroupDefs(): Record<string, BrColumnGroup> {
        const pbm = this.activePlanByMonths
        const defs: Record<string, BrColumnGroup> = {
            name: {
                key: 'name',
                label: this.columnsNameMap['name'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['name'],
            },
            utv_plan: {
                key: 'utv_plan',
                label: this.columnsNameMap['utv_plan'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['utv_plan'],
            },
            utoch_plan: {
                key: 'utoch_plan',
                label: this.columnsNameMap['utoch_plan'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['utoch_plan'],
            },
            skor_plan: {
                key: 'skor_plan',
                label: this.columnsNameMap['skor_plan'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['skor_plan'],
            },
            svod_plan: {
                key: 'svod_plan',
                label: this.columnsNameMap['svod_plan'],
                rowspan: 1,
                colspan: 2,
                subCols: [
                    { key: 'plat', label: this.columnsNameMap['plat'] },
                    { key: 'obaz', label: this.columnsNameMap['obaz'] },
                ],
                dataCols: ['plat', 'obaz'],
            },
            registrob: {
                key: 'registrob',
                label: this.columnsNameMap['registrob'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['registrob'],
            },
            utilization_percent: {
                key: 'utilization_percent',
                label: this.columnsNameMap['utilization_percent'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['utilization_percent'],
            },
            reason_plat: {
                key: 'reason_plat',
                label: this.columnsNameMap['reason_plat'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['reason_plat'],
            },
            reason_obaz: {
                key: 'reason_obaz',
                label: this.columnsNameMap['reason_obaz'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['reason_obaz'],
            },
            supplier: {
                key: 'supplier',
                label: this.columnsNameMap['supplier'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['supplier'],
            },
            date_text: {
                key: 'date_text',
                label: this.columnsNameMap['date_text'],
                rowspan: 1,
                colspan: 2,
                subCols: [
                    { key: 'beg_date', label: this.columnsNameMap['beg_date'] },
                    { key: 'end_date', label: this.columnsNameMap['end_date'] },
                ],
                dataCols: ['beg_date', 'end_date'],
            },
        }

        if (pbm) {
            defs['months_group'] = {
                key: 'months_group',
                label: this.columnsNameMap['months_group'],
                rowspan: 1,
                colspan: 12,
                subCols: this.monthColumns.map(mc => ({ key: mc, label: this.columnsNameMap[mc] })),
                dataCols: [...this.monthColumns],
            }
            defs['plan_month'] = {
                key: 'plan_month',
                label: this.columnsNameMap['plan_month'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['plan_month'],
            }
            defs['sumrg_group'] = {
                key: 'sumrg_group',
                label: this.columnsNameMap['sumrg_group'],
                rowspan: 1,
                colspan: 2,
                subCols: [
                    { key: 'sumrg', label: this.columnsNameMap['sumrg'] },
                    { key: 'curr_sumrg', label: this.columnsNameMap['curr_sumrg'] },
                ],
                dataCols: ['sumrg', 'curr_sumrg'],
            }
            defs['plan_remainder_group'] = {
                key: 'plan_remainder_group',
                label: this.columnsNameMap['plan_remainder_group'],
                rowspan: 1,
                colspan: 2,
                subCols: [
                    { key: 'plan_remainder_period', label: this.columnsNameMap['plan_remainder_period'] },
                    { key: 'plan_remainder_month', label: this.columnsNameMap['plan_remainder_month'] },
                ],
                dataCols: ['plan_remainder_period', 'plan_remainder_month'],
            }
        } else {
            defs['sumrg_group'] = {
                key: 'sumrg_group',
                label: this.columnsNameMap['sumrg_group'],
                rowspan: 2,
                colspan: 1,
                subCols: [],
                dataCols: ['sumrg'],
            }
        }

        return defs
    }

    public synchronizeVisibilityInTable() {
        this.$emit('update-indicators', cloneDeep(this.indicators))
        this.buildTableGroups()
    }

    public synchronizeIndicatorsOrder() {
        // Перестроить список показателей в новом порядке из tableGroups
        const indicatorGroups = this.tableGroups.filter(g => !g.fixed)
        const newOrder = indicatorGroups.map(g => g.key)

        const tempIndicators: Indicator[] = []
        // Добавить показатели, присутствующие в текущем виде (в новом порядке)
        newOrder.forEach(key => {
            const existing = this.indicators.find(it => it.key === key)
            if (existing) {
                tempIndicators.push(existing)
            }
        })
        // Добавить показатели, не попавшие в текущий вид (например months_group при !planByMonths)
        this.indicators.forEach(ind => {
            if (!tempIndicators.find(it => it.key === ind.key)) {
                tempIndicators.push(ind)
            }
        })

        this.indicators = tempIndicators
        this.$emit('update-indicators', cloneDeep(tempIndicators))
    }

    private openAll() {
        this.totalExpand = !this.totalExpand
        this.tableData?.forEach(i => {
            i.is_expanded = this.totalExpand
            if (i.level > 0) {
                i.visible = this.totalExpand
            }
        })
        const filtered = this._getFiltered()
        this.vsTotal = filtered.length
        this.initRowHeights(this.vsTotal)
        this.$nextTick(() => this.syncVirtualWindow())
    }

    private openChilds(row: ReportBrRow) {
        const parentIndex = (row as any)._dataIndex as number
        if (parentIndex === undefined || parentIndex === null) return
        row.is_expanded = !row.is_expanded
        const startSafe = Math.max(0, parentIndex + 1)
        const endSafe = Math.min(this.tableData.length - 1, parentIndex + (row as any).childs_count)
        for (let i = startSafe; i <= endSafe; i++) {
            this.tableData[i].visible = row.is_expanded
            this.tableData[i].is_expanded = row.is_expanded
        }
        const filtered = this._getFiltered()
        this.vsTotal = filtered.length
        this.initRowHeights(this.vsTotal)
        this.$nextTick(() => this.syncVirtualWindow())
    }

    public splitBy3(str: string): string {
        return str.match(/.{1,3}/g)?.join(' ') ?? '';
    }

    public formatDigitsGrouping = formatDigitsGrouping
}
